/**
 * DesktopNotAvailable Component
 * Shown when a non-admin user's active assignments are ALL morador/funcionario (or they
 * have none at all) — the desktop app is for operational staff (porteiro, zelador,
 * síndico, supervisor, admin, super_admin); residents and general employees use the
 * Panther Access mobile app instead.
 */

import React from 'react';
import { Smartphone, ShieldOff } from 'lucide-react';
import { useKeycloak } from '../contexts/KeycloakContext';

const DesktopNotAvailable: React.FC = () => {
  const { user, logout } = useKeycloak();

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="mx-auto w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6">
          <ShieldOff className="w-10 h-10 text-gray-400" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Aplicativo Desktop Indisponível
        </h1>

        {/* User Info */}
        <p className="text-gray-600 mb-6">
          Olá, <span className="font-medium">{user?.firstName || user?.name || 'Usuário'}</span>
        </p>

        {/* Message */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-amber-800">
            O aplicativo desktop é destinado à equipe operacional (portaria, zeladoria,
            síndicos e administradores). Sua conta tem acesso apenas como morador ou
            funcionário, que é gerenciado pelo aplicativo móvel Panther Access.
          </p>
        </div>

        {/* Info Card */}
        <div className="bg-gray-50 rounded-lg p-6 text-left">
          <h3 className="text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <Smartphone className="w-4 h-4" />
            Use o Aplicativo Móvel
          </h3>

          <p className="text-sm text-gray-600">
            Baixe o Panther Access na App Store ou Google Play para acessar suas
            informações, autorizar visitantes e muito mais.
          </p>
        </div>

        {/* Account Info */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500 mb-3">
            Conectado como: {user?.email || user?.username}
          </p>
          <button
            onClick={() => logout()}
            className="text-xs text-gray-500 underline hover:text-gray-700"
          >
            Sair
          </button>
        </div>
      </div>
    </div>
  );
};

export default DesktopNotAvailable;
